import { setup } from '~/core'
setup()

import '~/global/_alert'
import '~/global/_body'
import '~/global/_header'
import '~/global/_floating-tab'
import '~/global/_footer'
import '~/global/_siteModals'
import '~/global/_backToTop'

import '~/components/_accordion'
import '~/components/_calculatorGIC'
import '~/components/_calculatorHISA'
import '~/components/_floatingTab'
import '~/components/_forms'
import '~/components/_hero'
import '~/components/_iframeLoader'
import '~/components/_landingPageHero'
import '~/components/_jumpLink'
import '~/components/_rateTable'
import '~/components/_scrolly'
import '~/components/_tabs'
import '~/components/_testimonials'
import '~/components/_readMore'
import '~/components/_video'
